import { Ingredient } from "../types/ingredient";
import berberineImg from "../assets/img/ingredient-berberine.png";
import berberineImgWebp from "../assets/img/ingredient-berberine.webp";
import gymnemaImg from "../assets/img/ingredient-gymnema-sylvestre.png";
import gymnemaImgWebp from "../assets/img/ingredient-gymnema-sylvestre.webp";
import bitterImg from "../assets/img/ingredient-bitter-melon.png";
import bitterImgWebp from "../assets/img/ingredient-bitter-melon.webp";
import curcuminImg from "../assets/img/ingredient-curcumin.png";
import curcuminImgWebp from "../assets/img/ingredient-curcumin.webp";
import banabaImg from "../assets/img/ingredient-banaba.png";
import banabaImgWebp from "../assets/img/ingredient-banaba.webp";
import guggulImg from "../assets/img/ingredient-guggul.png";
import guggulImgWebp from "../assets/img/ingredient-guggul.webp";
import luteinImg from "../assets/img/ingredient-lutein.png";
import luteinImgWebp from "../assets/img/ingredient-lutein.webp";
import lyciumImg from "../assets/img/ingredient-lycium-barbarum.png";
import lyciumImgWebp from "../assets/img/ingredient-lycium-barbarum.webp";
import bilberryImg from "../assets/img/ingredient-bilberry.png";
import bilberryImgWebp from "../assets/img/ingredient-bilberry.webp";
import grapeImg from "../assets/img/ingredient-grape-seed.png";
import grapeImgWebp from "../assets/img/ingredient-grape-seed.webp";
import euphrasiaImg from "../assets/img/ingredient-euphrasia-officinalis.png";
import euphrasiaImgWebp from "../assets/img/ingredient-euphrasia-officinalis.webp";
import sophoraImg from "../assets/img/ingredient-sophora-japonica.png";
import sophoraImgWebp from "../assets/img/ingredient-sophora-japonica.webp";

export const glucoGenIngredients: Ingredient[] = [
    { name: "Berberine", benefit: "Powerful Blood Sugar Regulator", img: berberineImg, imgWebp: berberineImgWebp },
    { name: "Gymnema Sylvestre", benefit: "Sugar Destroyer", img: gymnemaImg, imgWebp:  gymnemaImgWebp },
    { name: "Bitter Melon", benefit: "Blood Sugar Stabilizer", img: bitterImg, imgWebp: bitterImgWebp },
    { name: "Curcumin", benefit: "Inflammation Fighter", img: curcuminImg, imgWebp: curcuminImgWebp },
    { name: "Banaba", benefit: "Glucose Stabilizer", img: banabaImg, imgWebp: banabaImgWebp },
    { name: "Guggul", benefit: "Metabolic Detoxifier", img: guggulImg, imgWebp: guggulImgWebp },
];

export const optiVistaIngredients: Ingredient[] = [
    { name: "Lutein", benefit: "Protects against age-related macular degeneration and filters harmful blue light.", img: luteinImg, imgWebp: luteinImgWebp },
    { name: "Lycium Barbarum", benefit: "Complements lutein in reducing oxidative stress and promoting retinal health.", img: lyciumImg, imgWebp: lyciumImgWebp },
    { name: "Bilberry Extract", benefit: "Rich in antioxidants that support night vision and circulation within the eyes.", img: bilberryImg, imgWebp: bilberryImgWebp },
    { name: "Grape Seed Extract", benefit: "Strong antioxidant properties that protect against oxidative damage and improve blood flow.", img: grapeImg, imgWebp: grapeImgWebp },
    { name: "Euphrasia Officinalis", benefit: "Traditionally used for reducing inflammation, soothing eye irritation, and improving overall eye comfort.", img: euphrasiaImg, imgWebp: euphrasiaImgWebp },
    { name: "Sophora Japonica", benefit: "Potent anti-inflammatory that strengthens eye tissues and protects against free radical damage.", img: sophoraImg, imgWebp: sophoraImgWebp },
];